(function(global){'use strict';const install=function(runtime){runtime.register("raptor-2",function(context){const {root,document,window,IntersectionObserver,ResizeObserver,requestAnimationFrame,cancelAnimationFrame,setTimeout,clearTimeout,setInterval,clearInterval,t:gtechT}=context;const errors=[];
try {

(()=>{"use strict";const panels=[...document.querySelectorAll("details.gtech-technical")];const expand=document.getElementById("gtech-raptor-2-expand-all");expand.hidden=false;const sync=()=>{const all=panels.every(p=>p.open);expand.textContent=all?gtechT('collapse_explanations_html'):gtechT('expand_explanations_html');expand.setAttribute("aria-label",expand.textContent);};expand.addEventListener("click",()=>{const open=!panels.every(p=>p.open);panels.forEach(p=>p.open=open);sync();});panels.forEach(p=>p.addEventListener("toggle",sync));const jump=document.getElementById("gtech-raptor-2-jump");jump.addEventListener("change",()=>{const target=document.getElementById(jump.value);if(target){location.hash=jump.value;target.setAttribute("tabindex","-1");target.focus({preventScroll:true});}});const sections=[...document.querySelectorAll("section.gtech-feature[id]")];const links=[...document.querySelectorAll("[data-nav]")];let ticking=false;let preferred=null;links.forEach(a=>a.addEventListener("click",()=>{preferred=a.dataset.nav;}));jump.addEventListener("change",()=>{preferred=jump.value;});const mark=()=>{const candidates=sections.filter(s=>s.getBoundingClientRect().top<=(Number(root.dataset.scrollThreshold)||160));const last=candidates[candidates.length-1]||sections[0];const row=candidates.filter(s=>Math.abs(s.getBoundingClientRect().top-last.getBoundingClientRect().top)<5);const chosen=row.find(s=>s.id===preferred)||row[0]||last;const current=chosen.id;links.forEach(a=>{if(a.dataset.nav===current)a.setAttribute("aria-current","location");else a.removeAttribute("aria-current");});if(document.activeElement!==jump)jump.value=current;ticking=false;};window.addEventListener("scroll",()=>{if(!ticking){requestAnimationFrame(mark);ticking=true;}},{passive:true});window.addEventListener("resize",mark);mark();})();

} catch (error) { errors.push({module:1,error}); }
try {

(()=>{"use strict";const buttons=[...document.querySelectorAll("[data-rise]")];const observation=document.querySelector(".gtech-rise-observation");const paths=[document.getElementById("gtech-raptor-2-crust-r1-dough"),document.getElementById("gtech-raptor-2-crust-dragon-dough")];function setRise(after){const h=after?42:10,t=250-h,c=250-.6*h;const d=`M135 250 C135 ${c} 137 ${t} 155 ${t} C177 ${t} 177 240 195 240 L375 240 C393 240 393 ${t} 415 ${t} C433 ${t} 435 ${c} 435 250 Z`;paths.forEach(p=>p.setAttribute("d",d));["gtech-raptor-2-crust-r1-callout","gtech-raptor-2-crust-dragon-callout"].forEach(id=>{const arrow=document.getElementById(id);if(arrow)arrow.setAttribute("d",`M216 190L183 199L158 ${t+8}`);});buttons.forEach(b=>b.setAttribute("aria-pressed",String((b.dataset.rise==="after")===after)));observation.textContent=after?gtechT('rise_after_r2_html'):gtechT('rise_before_html');}buttons.forEach(b=>b.addEventListener("click",()=>setRise(b.dataset.rise==="after")));})();

} catch (error) { errors.push({module:2,error}); }
try {


/* Conceptual flow animation. No computed CFD data, no automatic playback. */
(() => {
  'use strict';
  const root = document.getElementById('gtech-raptor-2-vortex-demo');
  if (!root || root.dataset.vortexReady === 'true') return;
  const play = root.querySelector('#gtech-raptor-2-vortex-play');
  const note = root.querySelector('#gtech-raptor-2-vortex-stage-note');
  const buttons = Array.from(root.querySelectorAll('[data-vortex-stage]'));
  if (!play || !note || buttons.length === 0) return;
  root.dataset.vortexReady = 'true';
  const notes = {
    "all": gtechT('vortex_overview_html'),
    "intake": gtechT('vortex_intake_html'),
    "bend": gtechT('vortex_bend_html'),
    "ports": gtechT('vortex_ports_html'),
    "flame": gtechT('vortex_flame_html')
};
  let wantsPlayback = false;
  let inView = true;
  const syncPlayback = () => {
    root.classList.toggle('gtech-is-playing', wantsPlayback && inView && !document.hidden);
    play.setAttribute('aria-pressed', String(wantsPlayback));
    const label = play.querySelector('[data-vortex-play-label]');
    if (label) label.textContent = wantsPlayback ? gtechT('pause_flow_html') : gtechT('play_flow_html');
    else play.textContent = wantsPlayback ? gtechT('pause_flow_html') : gtechT('play_flow_html');
  };
  const selectStage = (stage) => {
    const next = notes[stage] ? stage : 'all';
    root.dataset.stage = next;
    for (const button of buttons) {
      button.setAttribute('aria-pressed', String(button.dataset.vortexStage === next));
    }
    note.textContent = notes[next];
  };
  play.addEventListener('click', () => {
    wantsPlayback = !wantsPlayback;
    syncPlayback();
  });
  for (const button of buttons) {
    button.addEventListener('click', () => {
      const selected = button.dataset.vortexStage;
      selectStage(root.dataset.stage === selected ? 'all' : selected);
    });
  }
  document.addEventListener('visibilitychange', syncPlayback);
  if ('IntersectionObserver' in window) {
    const observer = new window.IntersectionObserver((entries) => {
      const entry = entries.find(item => item.target === root);
      if (!entry) return;
      inView = entry.isIntersecting;
      syncPlayback();
    }, { threshold: 0.05 });
    observer.observe(root);
  }
  // Every visitor, including a visitor preferring reduced motion, starts with a static diagram.
  selectStage(root.dataset.stage || 'all');
  syncPlayback();
})();



} catch (error) { errors.push({module:3,error}); }
try {

(function () {
  'use strict';

  var root = document.getElementById('gtech-raptor-2-inview-compare');
  if (!root || root.dataset.inviewComparisonReady === 'true') return;

  var turnButton = root.querySelector('#gtech-raptor-2-inview-turn');
  var turnLabel = root.querySelector('[data-inview-turn-label]');
  var turnDetail = root.querySelector('[data-inview-turn-detail]');
  var note = root.querySelector('#gtech-raptor-2-inview-comparison-note');
  var turned = root.dataset.turn === '1';
  var initialNote = gtechT('inview_initial_r2_html');
  var turnedNote = gtechT('inview_turned_r2_html');

  function sync() {
    root.dataset.mode = 'visibility';
    root.dataset.turn = turned ? '1' : '0';
    root.style.setProperty('--inview-r1-rotation', turned ? '90deg' : '0deg');
    root.style.setProperty('--inview-other-rotation', turned ? '180deg' : '0deg');
    if (turnButton) {
      turnButton.disabled = false;
      turnButton.setAttribute('aria-disabled', 'false');
      turnButton.setAttribute('aria-label', turned
        ? gtechT('reset_comparison_aria_html')
        : gtechT('turn_r2_aria_html'));
    }
    if (turnLabel) turnLabel.textContent = turned ? gtechT('reset_comparison_html') : gtechT('turn_pizza_html');
    if (turnDetail) turnDetail.textContent = turned ? gtechT('return_start_html') : gtechT('turn_degrees_r2_html');
    if (note) note.textContent = turned ? turnedNote : initialNote;
  }

  if (turnButton) {
    turnButton.addEventListener('click', function () {
      turned = !turned;
      sync();
    });
  }
  if (note) {
    note.setAttribute('aria-live', 'polite');
    note.setAttribute('aria-atomic', 'true');
  }
  root.dataset.inviewComparisonReady = 'true';
  sync();
}());


} catch (error) { errors.push({module:4,error}); }
try {
(function(){'use strict';const root=document.getElementById('gtech-raptor-2-rp-fire-demo');if(!root)return;const buttons=Array.from(root.querySelectorAll('[data-rp-stage]'));const copy=[[gtechT('fire_heat_title_html'), gtechT('fire_heat_body_html')], [gtechT('fire_draft_title_html'), gtechT('fire_draft_body_html')], [gtechT('fire_combustion_title_html'), gtechT('fire_combustion_body_html')]];buttons.forEach(button=>button.addEventListener('click',()=>{const stage=Number(button.dataset.rpStage);root.dataset.stage=String(stage);buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));document.getElementById('gtech-raptor-2-rp-stage-title').textContent=copy[stage][0];document.getElementById('gtech-raptor-2-rp-stage-text').textContent=copy[stage][1];}));}());
} catch (error) { errors.push({module:5,error}); }
try {
(function(){'use strict';
const joint=document.getElementById('gtech-raptor-2-tf-joint-demo');
if(joint){const buttons=Array.from(joint.querySelectorAll('[data-tf-state]'));const svg=joint.querySelector('.gtech-thermoflex-diagram');buttons.forEach(button=>button.addEventListener('click',()=>{const state=button.dataset.tfState;joint.dataset.state=state;svg.dataset.state=state;buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));document.getElementById('gtech-raptor-2-tf-state-note').textContent=state==='heated'?gtechT('flex_heated_html'):gtechT('flex_cold_html');}));}
}());
} catch (error) { errors.push({module:6,error}); }
try {
(function(){'use strict';
const panel=document.getElementById('gtech-raptor-2-ff128-air-demo');
if(!panel)return;
const diagram=panel.querySelector('.gtech-ff128-door-diagram');
if(!diagram)return;
const buttons=Array.from(panel.querySelectorAll('[data-ff128-air]'));
const status=document.getElementById('gtech-raptor-2-ff128-air-status');
const notes={"more": gtechT('fuel_more_air_html'), "less": gtechT('fuel_less_air_r2_html')};
buttons.forEach(button=>button.addEventListener('click',()=>{
 const state=button.dataset.ff128Air;
 if(!Object.prototype.hasOwnProperty.call(notes,state))return;
 panel.dataset.air=state;
 diagram.setAttribute('data-air',state);
 buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 status.textContent=notes[state];
}));
}());
} catch (error) { errors.push({module:7,error}); }
try {

/* Mobile figure enlargement preserves the actual diagram and its live state. */
(() => {
  'use strict';
  document.documentElement.classList.add('gtech-mobile-enhanced');
  const media = window.matchMedia('(max-width: 780px)');
  const selectors = [
    '.gtech-fullbake-graphic > img', '.gtech-fullbake-graphic > svg', '.gtech-masonry-oven > img', '.gtech-masonry-oven > svg',
    '.gtech-rise-diagrams > div > svg', '.gtech-ivcmp-top > svg', '.gtech-ivcmp-front > svg',
    '.gtech-vortex-svg-window > svg', '.gtech-rp-diagram > svg',
    '.gtech-construction-view > svg', '.gtech-fuelflex-diagram > svg'
  ];
  const figures = [];
  document.querySelectorAll(selectors.join(',')).forEach((graphic, index) => {
    const title = graphic.querySelector('title');
    const label = (title && title.textContent.trim()) || graphic.getAttribute('alt') || gtechT('technical_diagram_html');
    const viewBox = (graphic.getAttribute('viewBox') || '').trim().split(/\s+/);
    const intrinsicWidth = Number(viewBox[2]) || Number(graphic.getAttribute('width')) || 800;
    const expandedWidth = Math.max(720, Math.min(1450, intrinsicWidth * 1.25));
    const holder = document.createElement('div');
    holder.className = 'gtech-m130-figure';
    holder.style.setProperty('--figure-expanded-width', expandedWidth + 'px');
    const viewport = document.createElement('div');
    viewport.className = 'gtech-m130-viewport';
    viewport.id = 'gtech-raptor-2-figure-' + (index + 1);
    viewport.setAttribute('role', 'region');
    viewport.setAttribute('aria-label', label);
    const toolbar = document.createElement('div');
    toolbar.className = 'gtech-m130-tools';
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = gtechT('enlarge_diagram_html');
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-controls', viewport.id);
    button.setAttribute('aria-label', gtechT('enlarge_diagram_prefix_html') + label);
    const hint = document.createElement('span');
    hint.id = viewport.id + '-hint';
    hint.textContent = gtechT('swipe_explore_html');
    hint.hidden = true;
    toolbar.append(button, hint);
    graphic.parentNode.insertBefore(holder, graphic);
    holder.append(toolbar, viewport);
    viewport.append(graphic);
    const reset = () => {
      holder.classList.remove('gtech-is-enlarged');
      button.textContent = gtechT('enlarge_diagram_html');
      button.setAttribute('aria-pressed', 'false');
      button.setAttribute('aria-label', gtechT('enlarge_diagram_prefix_html') + label);
      hint.hidden = true;
      viewport.removeAttribute('tabindex');
      viewport.removeAttribute('aria-describedby');
      viewport.scrollLeft = 0;
      viewport.scrollTop = 0;
    };
    button.addEventListener('click', () => {
      if (!media.matches || holder.classList.contains('gtech-is-enlarged')) { reset(); return; }
      holder.classList.add('gtech-is-enlarged');
      button.textContent = gtechT('fit_diagram_html');
      button.setAttribute('aria-pressed', 'true');
      button.setAttribute('aria-label', gtechT('fit_diagram_prefix_html') + label);
      hint.hidden = false;
      viewport.setAttribute('tabindex', '0');
      viewport.setAttribute('aria-describedby', hint.id);
    });
    viewport.addEventListener('keydown', event => {
      if (event.key === 'Escape') { reset(); button.focus(); }
    });
    figures.push({ reset });
  });
  const onResize = () => { if (!media.matches) figures.forEach(figure => figure.reset()); };
  if (media.addEventListener) media.addEventListener('change', onResize);
  else media.addListener(onResize);
})();


} catch (error) { errors.push({module:8,error}); }
try {
(function(){
  'use strict';
  const C={mint:'#a8dfcf',amber:'#ffb650',steel:'#798b86',shell:'#303733',stone:'#d2c2a2'};
  const initial={yaw:.52,pitch:.29,mode:'insulation',region:'all'};
  const VIEWS={threequarter:[.52,.29],front:[0,.10],rear:[Math.PI-.5,.30],base:[.46,-.46]};
  const DETAILS={
    all:[gtechT('r2_insulation_all_title_html'),gtechT('r2_insulation_all_body_html')],
    upper:[gtechT('r2_insulation_upper_title_html'),gtechT('r2_insulation_upper_body_html')],
    rear:[gtechT('r2_insulation_rear_title_html'),gtechT('r2_insulation_rear_body_html')],
    base:[gtechT('r2_insulation_base_title_html'),gtechT('r2_insulation_base_body_html')]
  };
  function createModel(){
    const faces=[];
    function add(points,region,layer,kind='surface',colour){faces.push({points,region,layer,kind,colour});}
    function box(x0,x1,y0,y1,z0,z1,region,layer,colour){
      const v=[[x0,y0,z0],[x1,y0,z0],[x1,y1,z0],[x0,y1,z0],[x0,y0,z1],[x1,y0,z1],[x1,y1,z1],[x0,y1,z1]];
      [[0,1,2,3],[4,7,6,5],[0,4,5,1],[3,2,6,7],[0,3,7,4],[1,5,6,2]].forEach((i,n)=>add(i.map(j=>v[j]),region,layer,n===1?'front':'surface',colour));
    }
    // Photo-based faceted chamber geometry. Coordinates are display units, not dimensions.
    const inner=[[-1.80,-.44],[-1.87,.32],[-1.18,1.22],[-.64,1.38],[.64,1.38],[1.18,1.22],[1.87,.32],[1.80,-.44]];
    function offset(d){return inner.map(([x,y])=>[x+Math.sign(x)*d*.82,y+d*(y<0?.08:1)]);}
    function band(a,b,z0,z1,layer,region='upper'){
      for(let i=0;i<a.length-1;i++){
        const j=i+1;
        add([[...a[i],z0],[...a[j],z0],[...a[j],z1],[...a[i],z1]],region,layer,'inside');
        add([[...b[i],z0],[...b[i],z1],[...b[j],z1],[...b[j],z0]],region,layer,'surface');
        add([[...a[i],z1],[...a[j],z1],[...b[j],z1],[...b[i],z1]],region,layer,'front');
        add([[...a[i],z0],[...b[i],z0],[...b[j],z0],[...a[j],z0]],region,layer,'backcap');
      }
      [0,a.length-1].forEach(i=>add([[...a[i],z0],[...a[i],z1],[...b[i],z1],[...b[i],z0]],region,layer,'edge'));
    }
    band(inner,offset(.032),-1.27,1.35,0,'liner');
    band(offset(.036),offset(.143),-1.28,1.32,1);
    band(offset(.148),offset(.260),-1.38,1.32,2);
    band(offset(.267),offset(.293),-1.48,1.39,0,'body');
    function rearSlab(path,z0,z1,layer,region){
      function half(points,sign){let out=[];for(let i=0;i<points.length;i++){const p=points[i],q=points[(i+1)%points.length],a=p[0]*sign>=0,b=q[0]*sign>=0;if(a)out.push(p);if(a!==b){const t=-p[0]/(q[0]-p[0]);out.push([0,p[1]+t*(q[1]-p[1]),p[2]+t*(q[2]-p[2])]);}}return out;}
      if(region==='rear'){
        const back=path.map(p=>[...p,z0]),front=path.map(p=>[...p,z1]).reverse();
        add(half(back,1),region,layer,layer===2?'reveal':'surface');add(half(front,1),region,layer,layer===2?'reveal':'inside');
        add(half(back,-1),region,layer,'surface');add(half(front,-1),region,layer,'inside');
      }else{add(path.map(p=>[...p,z0]),region,layer,'surface');add(path.map(p=>[...p,z1]).reverse(),region,layer,'inside');}
      for(let i=0;i<path.length;i++){const j=(i+1)%path.length;add([[...path[i],z0],[...path[j],z0],[...path[j],z1],[...path[i],z1]],region,layer,'edge');}
    }
    rearSlab(inner,-1.27,-1.245,0,'liner');
    rearSlab(offset(.140),-1.37,-1.275,1,'rear');
    rearSlab(offset(.255),-1.475,-1.38,2,'rear');
    rearSlab(offset(.292),-1.505,-1.485,0,'body');
    // Both floor layers are separately modelled, with two visible front bands.
    box(-1.815,1.815,-.515,-.425,-1.26,1.365,'stone',0,C.stone);
    box(-1.92,1.92,-.548,-.523,-1.275,1.33,'liner',0,C.steel);
    box(-1.97,1.97,-.667,-.553,-1.37,1.34,'base',1);
    box(-2.055,2.055,-.793,-.674,-1.475,1.35,'base',2);
    box(-2.073,2.073,-.840,-.800,-1.495,1.40,'body',0,C.shell);
    // The front fascia keeps the recognisable angular R2 silhouette.
    const opening=[[-1.78,-.415],[-1.82,.18],[-1.24,.84],[1.24,.84],[1.82,.18],[1.78,-.415]];
    const fascia=[[-2.04,-.78],[-2.10,.35],[-1.35,1.49],[1.35,1.49],[2.10,.35],[2.04,-.78]];
    for(let i=0;i<opening.length-1;i++) add([[...opening[i],1.405],[...opening[i+1],1.405],[...fascia[i+1],1.405],[...fascia[i],1.405]],'fascia',0,'front',C.shell);
    // Low top outlet and feet; a small left control housing anchors orientation.
    box(-.58,.58,1.66,1.94,.28,.68,'hardware',0,'#343c37');
    box(-.49,.49,1.945,1.960,.34,.62,'outlet',0,'#0e1310');
    [-1.55,1.55].forEach(x=>[-.95,.95].forEach(z=>box(x-.17,x+.17,-1.02,-.84,z-.20,z+.20,'feet',0,'#252d27')));
    box(-2.42,-2.09,-.60,.25,.65,1.30,'control',0,'#353e38');
    return faces;
  }
  function project(p,state,w,h){
    const sy=Math.sin(state.yaw),cy=Math.cos(state.yaw),sp=Math.sin(state.pitch),cp=Math.cos(state.pitch);
    const x=p[0]*cy-p[2]*sy,y=-p[0]*sy*sp+p[1]*cp-p[2]*cy*sp,depth=p[0]*sy*cp+p[1]*sp+p[2]*cy*cp;
    const scale=Math.min(w/6.65,h/4.80),persp=8/(8-depth);
    return [w*.51+x*scale*persp,h*.51-y*scale*persp,depth];
  }
  function normal(points){const a=points[0],b=points[1],c=points[2];const u=b.map((v,i)=>v-a[i]),v=c.map((v,i)=>v-a[i]);const n=[u[1]*v[2]-u[2]*v[1],u[2]*v[0]-u[0]*v[2],u[0]*v[1]-u[1]*v[0]];const d=Math.hypot(...n)||1;return n.map(x=>x/d);}
  function colour(hex,k){const n=parseInt(hex.slice(1),16),r=Math.min(255,Math.round((n>>16)*k)),g=Math.min(255,Math.round(((n>>8)&255)*k)),b=Math.min(255,Math.round((n&255)*k));return `rgb(${r},${g},${b})`;}
  function appearance(f,state){
    const body=state.mode==='body';
    if(f.layer){
      if(body)return {alpha:0};
      const selected=state.region==='all'||state.region===f.region;
      let alpha=selected?(f.region==='base'?.96:f.region==='rear'?.50:.35):.045;
      if(selected&&f.kind==='front')alpha=.98;
      if(selected&&state.region!=='all')alpha=f.kind==='front'?.99:.66;
      if(state.region==='rear'&&f.region==='rear'&&f.layer===2&&f.kind==='reveal')alpha=.035;
      return {alpha,fill:f.layer===1?C.mint:C.amber,stroke:f.layer===1?'#c5f6e6':'#ffcb7c',line:f.kind==='front'?1.4:.8};
    }
    if(f.region==='stone')return {alpha:body?1:(state.region==='base'?.30:.70),fill:C.stone,stroke:'#eddfc6',line:.8};
    if(f.region==='body'||f.region==='fascia')return {alpha:body?1:(f.region==='fascia'?.12:.035),fill:C.shell,stroke:body?'#59645b':'#869990',line:body?1:1.0};
    if(f.region==='liner')return {alpha:body?.5:.05,fill:C.steel,stroke:'#a5b9af',line:.5};
    return {alpha:body?1:.38,fill:f.colour||C.shell,stroke:'#6b7d71',line:.7};
  }
  function rounded(ctx,x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+h,r);ctx.arcTo(x+w,y+h,x,y+h,r);ctx.arcTo(x,y+h,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath();}
  function label(ctx,text,sub,point,x,y,w,h,state,side){
    const anchor=project(point,state,w,h),small=w<430,bh=39;
    ctx.font=`700 ${small?11:12}px Arial,sans-serif`;const titleWidth=ctx.measureText(text).width;
    ctx.font='700 9px Arial,sans-serif';const subWidth=ctx.measureText(sub).width;
    const bw=Math.min(w-16,Math.max(small?102:123,Math.ceil(Math.max(titleWidth,subWidth))+18));
    x=Math.max(8,Math.min(w-bw-8,x));y=Math.max(10,Math.min(h-bh-34,y));
    const bx=side==='left'?x+bw:x,by=y+bh*.52;
    ctx.strokeStyle='#b7d5c6';ctx.lineWidth=1.1;ctx.globalAlpha=.85;ctx.beginPath();ctx.moveTo(anchor[0],anchor[1]);ctx.lineTo(bx,by);ctx.stroke();ctx.beginPath();ctx.arc(anchor[0],anchor[1],2.6,0,Math.PI*2);ctx.fillStyle='#e3f5e8';ctx.fill();
    ctx.globalAlpha=1;rounded(ctx,x,y,bw,bh,7);ctx.fillStyle='#192920f2';ctx.fill();ctx.strokeStyle='#466552';ctx.stroke();ctx.font=`700 ${small?11:12}px Arial,sans-serif`;ctx.fillStyle='#f4f1e8';ctx.fillText(text,x+9,y+15,bw-18);ctx.font='700 9px Arial,sans-serif';ctx.fillStyle='#a8dfcf';ctx.fillText(sub,x+9,y+29,bw-18);
  }
  function renderScene(ctx,w,h,state,faces){
    ctx.clearRect(0,0,w,h);const bg=ctx.createRadialGradient(w*.50,h*.43,10,w*.5,h*.45,w*.68);bg.addColorStop(0,'#263d31');bg.addColorStop(1,'#131d1a');ctx.fillStyle=bg;ctx.fillRect(0,0,w,h);
    const shadow=project([0,-1.035,0],state,w,h);ctx.save();ctx.translate(shadow[0],shadow[1]);ctx.scale(1,.20);const gr=ctx.createRadialGradient(0,0,0,0,0,w*.36);gr.addColorStop(0,'#0009');gr.addColorStop(1,'#0000');ctx.fillStyle=gr;ctx.beginPath();ctx.arc(0,0,w*.36,0,Math.PI*2);ctx.fill();ctx.restore();
    const sorted=faces.map(f=>{const p=f.points.map(v=>project(v,state,w,h));return {f,p,d:p.reduce((s,a)=>s+a[2],0)/p.length};}).sort((a,b)=>a.d-b.d);
    sorted.forEach(({f,p})=>{const a=appearance(f,state);if(a.alpha<.001)return;const n=normal(f.points),light=.77+.23*Math.abs(-.35*n[0]+.76*n[1]+.55*n[2]);ctx.globalAlpha=a.alpha;ctx.beginPath();ctx.moveTo(p[0][0],p[0][1]);p.slice(1).forEach(v=>ctx.lineTo(v[0],v[1]));ctx.closePath();ctx.fillStyle=colour(a.fill,light);ctx.fill();ctx.strokeStyle=a.stroke;ctx.lineWidth=a.line;ctx.stroke();});
    ctx.globalAlpha=1;
    if(Math.cos(state.yaw)>.15){const p=project([0,1.08,1.42],state,w,h);ctx.save();ctx.translate(p[0],p[1]);ctx.fillStyle=state.mode==='body'?'#f1eee7':'#e8eade88';ctx.textAlign='center';ctx.font=`800 ${Math.max(10,w*.024)}px Arial,sans-serif`;ctx.fillText('GLOWEN',0,0);ctx.font=`600 ${Math.max(8,w*.014)}px Arial,sans-serif`;ctx.fillText('Raptor 2',0,Math.max(11,w*.020));ctx.restore();}
    if(state.mode!=='body'){
      if(state.region==='all'){
        label(ctx,gtechT('canvas_upper_sides_html'),gtechT('canvas_two_layers_html'),[.85,1.69,.5],w*.68,h*.085,w,h,state,'right');
        label(ctx,gtechT('canvas_rear_wall_html'),gtechT('canvas_two_layers_html'),[-1.45,.65,-1.40],w*.028,h*.18,w,h,state,'left');
        label(ctx,gtechT('canvas_below_stone_html'),gtechT('canvas_two_layers_html'),[1.72,-.70,1.37],w*.70,h*.77,w,h,state,'right');
      }else if(state.region==='base'){
        label(ctx,gtechT('canvas_layer_one_html'),gtechT('canvas_beneath_stone_html'),[1.60,-.607,1.35],w*.65,h*.70,w,h,state,'right');
        label(ctx,gtechT('canvas_layer_two_html'),gtechT('canvas_beneath_first_layer_html'),[.45,-.734,1.36],w*.14,h*.80,w,h,state,'left');
      }else if(state.region==='rear'){
        label(ctx,gtechT('canvas_layer_one_html'),gtechT('canvas_chamber_side_html'),[1.27,.53,-1.32],w*.04,h*.30,w,h,state,'left');
        label(ctx,gtechT('canvas_layer_two_html'),gtechT('canvas_outer_side_html'),[-1.10,.78,-1.43],w*.74,h*.29,w,h,state,'right');
      }else{
        label(ctx,gtechT('canvas_layer_one_html'),gtechT('canvas_chamber_side_html'),[-.4,1.48,1.33],w*.09,h*.16,w,h,state,'left');
        label(ctx,gtechT('canvas_layer_two_html'),gtechT('canvas_outer_side_html'),[.7,1.65,1.33],w*.72,h*.18,w,h,state,'right');
      }
    }
  }
  function init(){
    const root=document.getElementById('gtech-raptor-2-r2i-viewer');if(!root)return;const canvas=root.querySelector('#gtech-raptor-2-r2i-canvas'),ctx=canvas.getContext('2d');if(!ctx)return;
    const state={...initial},faces=createModel();let width=600,height=460,scheduled=false,drag=null;
    function draw(){scheduled=false;ctx.setTransform(canvas.width/width,0,0,canvas.height/height,0,0);renderScene(ctx,width,height,state,faces);}
    function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(draw);}}
    function size(){const r=canvas.getBoundingClientRect();width=r.width||600;height=r.height||450;const d=Math.min(window.devicePixelRatio||1,2);canvas.width=Math.round(width*d);canvas.height=Math.round(height*d);schedule();}
    const detail=root.querySelector('#gtech-raptor-2-r2i-detail');
    function pressed(attr,value){root.querySelectorAll('['+attr+']').forEach(b=>b.setAttribute('aria-pressed',String(b.getAttribute(attr)===value)));}
    function view(name){[state.yaw,state.pitch]=VIEWS[name];pressed('data-r2i-view',name);schedule();}
    root.querySelectorAll('[data-r2i-mode]').forEach(b=>b.addEventListener('click',()=>{state.mode=b.dataset.r2iMode;root.dataset.r2iMode=state.mode;pressed('data-r2i-mode',state.mode);if(state.mode==='body'){setDetail(gtechT('r2_body_title_html'), gtechT('r2_body_description_html'));}else updateDetail();schedule();}));
    function setDetail(title, description){const heading=document.createElement('b'),paragraph=document.createElement('p');heading.textContent=title;paragraph.textContent=description;detail.replaceChildren(heading,paragraph);}
    function updateDetail(){const d=DETAILS[state.region];setDetail(d[0],d[1]);}
    root.querySelectorAll('[data-r2i-region]').forEach(b=>b.addEventListener('click',()=>{state.region=b.dataset.r2iRegion;state.mode='insulation';root.dataset.r2iMode=state.mode;pressed('data-r2i-mode','insulation');pressed('data-r2i-region',state.region);view(state.region==='rear'?'rear':state.region==='base'?'front':'threequarter');if(state.region==='base')state.pitch=.08;updateDetail();schedule();}));
    root.querySelectorAll('[data-r2i-view]').forEach(b=>b.addEventListener('click',()=>view(b.dataset.r2iView)));
    canvas.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button!==0)return;drag={x:e.clientX,y:e.clientY,yaw:state.yaw,pitch:state.pitch,id:e.pointerId};canvas.setPointerCapture(e.pointerId);canvas.classList.add('gtech-r2i-dragging');});
    canvas.addEventListener('pointermove',e=>{if(!drag||drag.id!==e.pointerId)return;state.yaw=drag.yaw+(e.clientX-drag.x)*.009;state.pitch=Math.max(-.68,Math.min(.78,drag.pitch+(e.clientY-drag.y)*.007));pressed('data-r2i-view','');schedule();});
    function end(){drag=null;canvas.classList.remove('gtech-r2i-dragging');}canvas.addEventListener('pointerup',end);canvas.addEventListener('pointercancel',end);canvas.addEventListener('lostpointercapture',end);
    canvas.addEventListener('keydown',e=>{const k=e.key;if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home'].includes(k))return;e.preventDefault();if(k==='Home'){view('threequarter');return;}if(k==='ArrowLeft')state.yaw-=.13;if(k==='ArrowRight')state.yaw+=.13;if(k==='ArrowUp')state.pitch=Math.min(.78,state.pitch+.10);if(k==='ArrowDown')state.pitch=Math.max(-.68,state.pitch-.10);pressed('data-r2i-view','');schedule();});
    if(typeof ResizeObserver!=='undefined')new ResizeObserver(size).observe(canvas);else window.addEventListener('resize',size);size();
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={createModel,project,renderScene,initial,VIEWS,appearance,DETAILS};
  if(typeof document!=='undefined'){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();}
})();

} catch (error) { errors.push({module:9,error}); }
if(errors.length){root.dataset.technologyErrors=String(errors.length);errors.forEach(item=>global.console.error('Glowen technology module failed',"raptor-2",item.module,item.error));} });};if(global.GlowenTechnologyPages)install(global.GlowenTechnologyPages);else(global.GlowenTechnologyQueue=global.GlowenTechnologyQueue||[]).push(install);})(window);